module.exports = __webpack_public_path__ + "img/custom-app-side.4265c2c3.png";